import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "tab-scroll-container"
};
var _hoisted_2 = ["disabled"];
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["disabled"];
var _hoisted_5 = {
  class: "sort-btn"
};
var _hoisted_6 = {
  class: "sort-box"
};
var _hoisted_7 = {
  class: "label-name"
};
var _hoisted_8 = {
  class: "move-icon"
};
import { ref, onMounted, nextTick, toRaw, onUpdated } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { getSubjectList, updateSubjectList } from '@/api/home';
import { ChevronLeftIcon, ChevronRightIcon } from 'tdesign-icons-vue-next';
import draggable from 'vuedraggable';
export default {
  __name: 'SubjectTab',
  props: {
    initialTab: {
      type: Number,
      default: 0
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var localTabs = ref([]);
    var activeTab = ref(props.initialTab);
    var tabsWrapper = ref(null);
    var tabsContainer = ref(null);
    var tabButtons = ref([]);

    // 滚动位置相关状态
    var isLeftScrollDisabled = ref(true);
    var isRightScrollDisabled = ref(false);

    // 使用函数式ref确保动态引用正确
    var setTabButtonRef = function setTabButtonRef(el, index) {
      if (el) {
        tabButtons.value[index] = el;
      }
    };
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _yield$getSubjectList, data, all;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return getSubjectList();
          case 1:
            _yield$getSubjectList = _context.v;
            data = _yield$getSubjectList.data;
            all = {
              id: '',
              code: '',
              displayName: '全部'
            };
            localTabs.value = (data === null || data === void 0 ? void 0 : data.data) || [];
            // 如果 showAll 为 true，则在头部添加 "全部" 选项
            if (props.showAll) {
              localTabs.value.unshift(all);
            }
            _context.n = 2;
            return nextTick(function () {
              scrollToTab(activeTab.value);
              // 添加滚动事件监听
              if (tabsWrapper.value) {
                tabsWrapper.value.addEventListener('scroll', handleScroll);
                handleScroll(); // 初始化滚动状态
              }
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));

    // 更新时检查滚动状态
    onUpdated(function () {
      handleScroll();
    });

    // 处理滚动事件，更新滚动按钮状态
    var handleScroll = function handleScroll() {
      if (!tabsWrapper.value) return;
      var _tabsWrapper$value = tabsWrapper.value,
        scrollLeft = _tabsWrapper$value.scrollLeft,
        scrollWidth = _tabsWrapper$value.scrollWidth,
        clientWidth = _tabsWrapper$value.clientWidth;

      // 判断是否可以向左滚动
      isLeftScrollDisabled.value = scrollLeft <= 0;

      // 判断是否可以向右滚动（减10是为了避免浮点精度问题）
      isRightScrollDisabled.value = scrollLeft >= scrollWidth - clientWidth - 10;
    };

    // 向左滚动，不切换选中标签
    var scrollToPrev = function scrollToPrev() {
      if (!tabsWrapper.value || tabButtons.value.length === 0) return;
      var wrapper = tabsWrapper.value;
      var wrapperRect = wrapper.getBoundingClientRect();

      // 找到当前可视区域中最左边的按钮（允许部分可见）
      var leftmostButton = null;
      var minLeft = Infinity;
      tabButtons.value.forEach(function (button, index) {
        if (button) {
          var buttonRect = button.getBoundingClientRect();
          // 只要按钮有一部分在可视区域内，或者左边缘在可视区域附近
          if (buttonRect.right >= wrapperRect.left - 10) {
            if (buttonRect.left < minLeft) {
              minLeft = buttonRect.left;
              leftmostButton = index;
            }
          }
        }
      });

      // 如果找到了最左边的按钮且不是第一个按钮，则滚动到前一个按钮
      if (leftmostButton !== null && leftmostButton > 0) {
        var prevButton = tabButtons.value[leftmostButton - 1];
        if (prevButton) {
          // 滚动到前一个按钮的位置
          var buttonRect = prevButton.getBoundingClientRect();
          var scrollOffset = wrapper.scrollLeft + (buttonRect.left - wrapperRect.left);
          wrapper.scrollTo({
            left: scrollOffset,
            behavior: 'smooth'
          });
        }
      }
    };

    // 向右滚动，不切换选中标签
    var scrollToNext = function scrollToNext() {
      if (!tabsWrapper.value || tabButtons.value.length === 0) return;
      var wrapper = tabsWrapper.value;
      var wrapperRect = wrapper.getBoundingClientRect();

      // 找到当前可视区域中最右边的按钮
      var rightmostVisibleButton = null;
      var maxRight = -Infinity;
      tabButtons.value.forEach(function (button, index) {
        if (button) {
          var buttonRect = button.getBoundingClientRect();
          // 按钮右边缘在容器右边缘左侧，且完全在可视区域内
          if (buttonRect.right <= wrapperRect.right && buttonRect.left >= wrapperRect.left) {
            if (buttonRect.right > maxRight) {
              maxRight = buttonRect.right;
              rightmostVisibleButton = index;
            }
          }
        }
      });

      // 如果找到了最右边的按钮且不是最后一个按钮，则滚动到下一个按钮
      if (rightmostVisibleButton !== null && rightmostVisibleButton < tabButtons.value.length - 1) {
        var nextButton = tabButtons.value[rightmostVisibleButton + 1];
        if (nextButton) {
          // 滚动到下一个按钮的位置
          var buttonRect = nextButton.getBoundingClientRect();
          var scrollOffset = buttonRect.right - wrapperRect.right;
          wrapper.scrollTo({
            left: wrapper.scrollLeft + scrollOffset,
            behavior: 'smooth'
          });
        }
      }
    };
    var selectTab = function selectTab(index) {
      activeTab.value = index;
      scrollToTab(index);
    };
    var scrollToTab = function scrollToTab(index) {
      nextTick(function () {
        var _tabsContainer$value;
        // 确保tabButtons引用已更新
        if (!tabsWrapper.value || !tabButtons.value[index]) {
          return;
        }
        emit('change', toRaw(localTabs.value[index]));
        var wrapper = tabsWrapper.value;
        var button = tabButtons.value[index];
        var wrapperRect = wrapper.getBoundingClientRect();
        var buttonRect = button.getBoundingClientRect();

        // 计算标签中心位置
        var buttonCenter = buttonRect.left + buttonRect.width / 2;
        var wrapperCenter = wrapperRect.left + wrapperRect.width / 2;

        // 计算需要滚动的距离
        var scrollOffset = buttonCenter - wrapperCenter;

        // 计算目标滚动位置
        var targetScroll = wrapper.scrollLeft + scrollOffset;

        // 确保不会滚动过头
        var maxScroll = ((_tabsContainer$value = tabsContainer.value) === null || _tabsContainer$value === void 0 ? void 0 : _tabsContainer$value.$el.scrollWidth) - wrapperRect.width || 0;
        targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

        // 执行滚动
        wrapper.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      });
    };
    var onMove = function onMove(event) {
      // 被拖拽的元素
      var draggedElement = event.draggedContext.element;
      // 如果拖拽的元素没有code属性（即"全部"标签），则禁止拖拽
      if (!(draggedElement !== null && draggedElement !== void 0 && draggedElement.code)) {
        return false;
      }

      // 目标位置元素
      var relatedElement = event.relatedContext.element;
      // 如果目标位置是"全部"标签，也禁止拖拽
      if (!(relatedElement !== null && relatedElement !== void 0 && relatedElement.code)) {
        return false;
      }
      return true;
    };
    var onDragEnd = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _toRaw, newTabs, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              // 拖拽结束后重置按钮引用
              tabButtons.value = [];
              newTabs = (_toRaw = toRaw(localTabs.value)) === null || _toRaw === void 0 ? void 0 : _toRaw.map(function (tab, index) {
                return {
                  subjectCode: tab.code,
                  sort: index + 1
                };
              });
              _context2.n = 1;
              return updateSubjectList(newTabs);
            case 1:
              _context2.n = 2;
              return MessagePlugin.success('操作成功');
            case 2:
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              MessagePlugin.error((_t === null || _t === void 0 ? void 0 : _t.message) || '修改学科顺序失败');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 3]]);
      }));
      return function onDragEnd() {
        return _ref3.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_popup = _resolveComponent("t-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
        class: "scroll-button left",
        disabled: isLeftScrollDisabled.value,
        onClick: scrollToPrev
      }, [_createVNode(_unref(ChevronLeftIcon), {
        size: "18px"
      })], 8, _hoisted_2), _createElementVNode("div", {
        class: "tabs-wrapper",
        ref_key: "tabsWrapper",
        ref: tabsWrapper
      }, [_createVNode(_unref(draggable), {
        modelValue: localTabs.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return localTabs.value = $event;
        }),
        class: "tabs-container",
        animation: 300,
        "ghost-class": "ghost-tab",
        "chosen-class": "chosen-tab",
        "item-key": "value",
        onEnd: onDragEnd,
        move: onMove,
        filter: '.not-draggable',
        ref_key: "tabsContainer",
        ref: tabsContainer
      }, {
        item: _withCtx(function (_ref4) {
          var element = _ref4.element,
            index = _ref4.index;
          return [_createElementVNode("button", {
            class: _normalizeClass(["tab", {
              active: activeTab.value === index,
              'not-draggable': !(element !== null && element !== void 0 && element.code)
            }]),
            onClick: function onClick($event) {
              return selectTab(index);
            },
            ref: function ref(el) {
              return setTabButtonRef(el, index);
            }
          }, _toDisplayString(element.displayName), 11, _hoisted_3)];
        }),
        _: 1
      }, 8, ["modelValue"])], 512), _createElementVNode("button", {
        class: "scroll-button right",
        disabled: isRightScrollDisabled.value,
        onClick: scrollToNext
      }, [_createVNode(_unref(ChevronRightIcon), {
        size: "18px"
      })], 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createVNode(_component_t_popup, {
        trigger: "click",
        placement: "bottom-start"
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_6, [_createVNode(_unref(draggable), {
            modelValue: localTabs.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return localTabs.value = $event;
            }),
            filter: '.not-draggable',
            onEnd: onDragEnd,
            move: onMove,
            animation: 300,
            "item-key": "value",
            handle: ".move-icon",
            class: "sort-list"
          }, {
            item: _withCtx(function (_ref5) {
              var element = _ref5.element;
              return [_createElementVNode("div", {
                class: _normalizeClass(["sort-item", {
                  'not-draggable': !(element !== null && element !== void 0 && element.code)
                }])
              }, [_createElementVNode("div", _hoisted_7, _toDisplayString(element.displayName), 1), _createElementVNode("div", _hoisted_8, [_createVNode(_component_svg_icon, {
                name: "move2",
                class: "move-svg"
              })])], 2)];
            }),
            _: 1
          }, 8, ["modelValue"])])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_svg_icon, {
            name: "sort2",
            class: "sort-icon",
            size: "20"
          })];
        }),
        _: 1
      })])]);
    };
  }
};